import { render, staticRenderFns } from "./PdpCarousel.vue?vue&type=template&id=f1d342de&lang=pug&"
import script from "./PdpCarousel.vue?vue&type=script&lang=js&"
export * from "./PdpCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PdpCarousel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports